/**
 * R2 standalone config(maintenance/events/notices/ads)의 web2/web3 분기 헬퍼.
 *
 * 파일 canonical 형태는 `{ web2: <Config>, web3: <Config> }`. 레거시(평탄) 발행본은
 * 그대로 두고 클라가 전체를 config 로 간주하도록 폴백한다 — 재발행 전 무중단.
 */
export type R2Flavor = 'web2' | 'web3';

/** nested({web2,web3}) 형태인지. null/배열/원시값은 false(=평탄 취급). */
export function isFlavored(data: unknown): data is { web2: unknown; web3: unknown } {
  return (
    typeof data === 'object' &&
    data !== null &&
    !Array.isArray(data) &&
    'web2' in data &&
    'web3' in data
  );
}

/** nested 면 해당 flavor 섹션, 아니면(레거시 평탄) 전체를 반환. */
export function pickFlavor<T>(data: unknown, flavor: R2Flavor): T {
  if (isFlavored(data)) return (data as Record<R2Flavor, T>)[flavor];
  return data as T;
}

/** 두 flavor 섹션을 canonical nested 로 묶는다(EF/admin 발행용). */
export function wrapFlavors<T>(web2: T, web3: T): { web2: T; web3: T } {
  return { web2, web3 };
}
